<template>
	<div class="header" ref="header">
		<div class="header_box">
			<div class="headerTop fc">
				<a href="" class="logo">
					<img src="@/assets/home/home_logo.png" alt="" />
					<!-- <img :src="showUrl + logoImg" alt="" /> -->
				</a>
				<div class="operation">
					<div class="nologin" v-if="!token">
						<!-- <router-link :to="" tag="a">登录</router-link> -->
						<a class="login" @click="goToLogin">登录</a>
						<a class="register" @click="goToRegister">注册</a>
					</div>
					<div class="user" v-else>
						<p class="link">
							<a :href="platformUrl + '/control/'" target="_blank">控制台</a>
						</p>
						
						<el-dropdown placement="bottom-start" @command="changeEnterprise">
							<div class="el-dropdown-link">
								<img :src="userInfo.buddha ? showUrl + userInfo.buddha : require('@/assets/icon_head.png')"
									alt="" class="buddha">
								<div style="display:inline-block" class="dropdown-info">
									<p>{{ userInfo.nickname }}</p>
									<p class="ellipsis" v-if="selectEnterprise.enterpriseId">{{ selectEnterprise.enterpriseName
									}}
									</p>
								</div>
								<i class="el-icon-arrow-down el-icon--right"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="index"
									:class="selectEnterprise.enterpriseId === item.enterpriseId ? 'active' : ''"
									v-for="(item, index) in enterpriseList" :key="item.enterpriseId">{{ item.enterpriseName
									}}</el-dropdown-item>
								<el-dropdown-item divided @click.native="logOut">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
		</div>
		<div class="headerUl">
			<ul class="menu fc">
				<li :class="access == 'home' ? 'active' : ''" @click="goTo('/home')" @mousemove="maskClose">
					首页
				</li>
				<li :class="access == 'paas' ? 'active' : ''" @click="goTo('/paas')"
				@mousemove="maskClose">
					PaaS平台
				</li>
				<!-- <li :class="access == 'applyCenter' ? 'active' : ''" @click="goTo('/applyCenter')" @mousemove="maskClose">
					应用中心
				</li>
				<li :class="access == 'solution' ? 'active' : ''" @click="goTo('/solution')" @mousemove="maskClose">
					解决方案
				</li>
				<li :class="access == 'demand' ? 'active' : ''" @click="goTo('/demand')" @mousemove="maskClose">
					供需对接
				</li>
				<li :class="access == 'productRelease' ? 'active' : ''" @click="goTo('/productRelease')" @mousemove="maskClose">
					工业品发布
				</li> -->
				<!-- <li :class="access == 'tools' ? 'active' : ''"  @mousemove="serviceShow=false;industryShow=true;edgeShow=false">
                    行业应用
                </li> -->
				<li :class="access == 'applyWeb' ? 'active' : ''">
					<a :href="platformUrl + '/applyWeb/'" target="_blank">应用市场</a>
				</li>
				<li :class="access == 'developer' ? 'active' : ''">
					<a :href="platformUrl + '/developerWeb/#/community'" target="_blank">开发者社区</a>
				</li>	
				<li :class="access == 'serve' ? 'active' : ''">
					<a :href="platformUrl + '/openWeb/'" target="_blank">开放平台</a>
				</li>			
				<!-- <li :class="access == 'wasteCloud' ? 'active' : ''" @click="goTo('/wasteCloud')" @mousemove="maskClose">
                    钢构云
                </li> -->

				<!-- <li :class="access == 'security' ? 'active' : ''" @click="goTo('/security')" @mousemove="maskClose">
                    安全体系
                </li> -->
				<li :class="access == 'information' ? 'active' : ''" @click="goTo('/platform/information')"
					@mousemove="maskClose">
					平台资讯
				</li>
				<li :class="access == 'platform' ? 'active' : ''" @click="goTo('/platform')" @mousemove="maskClose">
					关于卫龙
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { platformUrl, getClassifyList, getPortalProductList, getPortalDeviceList, showUrl, getUserEnterprise, switchUserEnterprise, loginOut } from '@/api/api'
import { getCallUrl } from '@/utils/auth.js'
import applyData from '@/utils/applyData.js'
export default {
	name: "",
	components: {},
	data() {
		return {
			access: "",
			phone: "",
			platformUrl,
			serviceShow: false,
			industryShow: false, // 行业应用
			edgeShow: false, // 边缘层
			edgeId: '',
			edgeList: [],
			edgeIndex: 0,
			applyData,
			applyUrl: platformUrl + '/applyWeb/#/applyInfo?appId=',
			applicationList: [],
			userInfo: {},
			token: '',
			showUrl,
			enterpriseList: [],
			selectEnterprise: {
				enterpriseName: '',
				enterpriseId: ''
			},
			logoImg: '',
		};
	},
	created() {
		// 获取网站信息
		if (localStorage.getItem('basicSet')) {
			this.logoImg = JSON.parse(localStorage.getItem('basicSet')).homeHeaderLogo
		}
	},
	mounted() {
		this.getApplication()
		this.getLineList()
		if (this.token) {
			this.getEnterpriseList()
		}
		window.addEventListener("scroll", this.scrolling);
	},
	methods: {
		goToLogin() {
			getCallUrl()
		},
		goToRegister() {
			getCallUrl('register')
		},
		// 获取行业应用
		getApplication() {
			getClassifyList().then(res => {
				if (res.code === 0) {
					this.applicationList = res.data
				}
			})
		},
		// 获取设备列表
		getEquipment(deviceType) {
			this.edgeList = []
			let data = {
				deviceType,
				state: 1
			}
			getPortalDeviceList(data).then(res => {
				if (res.code === 0) {
					this.edgeList = res.data.data
				}
			})
		},
		// 获取产线方案
		getLineList() {
			this.edgeList = []
			getPortalProductList({ state: 1 }).then(res => {
				if (res.code === 0) {
					this.edgeList = res.data.data
				}
			})
		},
		// 获取企业信息
		getEnterpriseList() {
			getUserEnterprise().then(res => {
				if (res.code === 0) {
					this.enterpriseList = res.data
					let checkEnterprise = this.enterpriseList.filter(item => item.isCheck === 1)
					if (checkEnterprise.length == 0) return
					this.selectEnterprise = checkEnterprise[0]
				}
			})
		},
		// 切换企业
		changeEnterprise(index) {
			console.log(index)
			let data = {
				id: this.enterpriseList[index].enterpriseId
			}
			switchUserEnterprise(data).then(res => {
				if (res.code === 0) {
					this.selectEnterprise = this.enterpriseList[index]
					this.getApplication()
					this.getLineList()
				}
			})
		},
		goTo(path) {
			this.$router.push({ path })
		},
		goToEdge(row) {
			if (this.edgeIndex === 0) {
				this.$router.push({ path: '/edge/scheme', query: { id: row.productLineId } });
			} else {
				this.$router.push({ path: '/edge/equipment', query: { id: row.deviceId } });
			}

		},
		// 跳转至平台其他系统
		goToPlatform(url) {
			// window.location.href = platformUrl + url
			window.open(platformUrl + url)
		},
		goToEditPwd() {
			window.location.href = platformUrl + '/amend.html'
		},
		logOut() {
			let data = {
				identify: this.$variable.identify
			}
			loginOut(data).then(res => {
				if (res.code == 0) {
					localStorage.clear()
					this.token = ""
					this.$message.success('退出成功')
					if (process.env.NODE_ENV === 'development') {
						// next(`/login?redirect=${to.path}`)
					} else {
						// getCallUrl()
						window.location.href = platformUrl
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		maskClose() {
			this.serviceShow = false
			this.industryShow = false
			this.edgeShow = false
		},
		// 监听滚动事件更改 header 透明度
		scrolling() {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 180) {
				this.$refs.header.style.background = '#fff'
			} else {
				this.$refs.header.style.background = 'rgba(255,255,255,0.8)'
			}
		}
	},
	watch: {
		$route: {
			handler(val) {
				this.access = val.meta.access;
				this.edgeId = val.query.id
				if (!this.token) {
					this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
					this.token = localStorage.getItem("tokenValue") || ""
				}
			},
			// 深度观察监听
			deep: true,
			immediate: true
		},
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrolling)
	}
};
</script>

<style lang="less" scoped>
.header {
	
	width: 100%;
	font-size: 14px;
	position: sticky;
	top: 0;
	left: 0;
	z-index: 999;

	// box-shadow: 0 4px 10px 2px rgb(194 196 209 / 60%);

	.control {
		margin-right: 20px;
		cursor: pointer;
	}

	.header_box {
		height: 66px;
		margin: auto;
		background-color: #ffffff;
		box-shadow: 0px 19px 16px 0px rgba(230, 0, 18, 0.04);
		.headerTop{
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.logo {
			font-size: 16px;
			margin-right: 80px;
			margin-left: 24px;

			.curr {
				font-size: 22px;
			}

			img {
				vertical-align: middle;
				margin-right: 9px;
			}

			span {
				vertical-align: bottom;
			}
		}

		.operation {
			height: 66px;
			line-height: 66px;
			text-align: center;
			padding-right: 30px;

			.register {
				width: 104px;
				height: 66px;
				display: inline-block;
				background: #e60012;
				color: #ffffff;
			}

			.login {
				padding: 0 25px;
			}

			.user {
				display: flex;
				align-items: center;
				.link {
					margin-right: 20px;
					width: 106px;
					height: 32px;
					line-height: 32px;
					background-color: #e60012;
					text-align: center;
					color: #fff;
				}

				.buddha {
					width: 32px;
					height: 32px;
					border-radius: 16px;
					vertical-align: middle;
					margin-right: 16px;
				}

				.dropdown-info {
					display: inline-block;
					vertical-align: middle;
					width: 114px;
					text-align: left;
					margin-right: 10px;

					p {
						line-height: 18px;
						color: #222222;

						&.ellipsis {
							margin-top: 6px;
							font-size: 12px;
							color: #e60012;
						}
					}
				}
			}
		}
	}
	.headerUl{
		background-color: #e60012;
	}
	.menu {
			display: flex;
			height: 100%;
			flex: 1;
			color: #fff;
			li {
				line-height: 48px;
				// margin-right: 30px;
				cursor: pointer;
				width: 174px;
				height: 48px;
				text-align: center;
				font-size: 16px;
				margin-right: 10px;
				a{
					display: inline-block;
					width: 165px;
				}
				&.active {
					background-color: rgba(255, 255, 255, 0.3);
				}

				&:hover {
					background-color: rgba(255, 255, 255, 0.3);
				}

			}
		}

	.mask {
		background: rgba(255, 255, 255, 0.9);
		width: 100%;
		padding: 54px 0;
		position: absolute;
		left: 0;
		top: 64px;
		z-index: 999;
	}

	.service {

		.nav {
			display: flex;
			flex-wrap: wrap;

			.nav_item {
				width: 290px;
				margin-right: 20px;
				margin-bottom: 20px;

				&:nth-of-type(4n) {
					margin-right: 0;
				}

				display: flex;
				align-items: center;
				cursor: pointer;

				.hover {
					display: none;
				}

				&:hover {
					.default {
						display: none;
					}

					.hover {
						display: block;
					}
				}

				.info {
					margin-left: 10px;

					h3 {
						font-weight: 400;
					}

					p {
						font-size: 14px;
						color: #666666;
						margin-top: 10px;
					}
				}
			}
		}
	}

	.industry {
		.left {
			width: calc(20% - 30px);
			margin-right: 45px;
		}

		.left:nth-of-type(3n) {
			margin-right: 0;
			margin-bottom: 40px;
			width: calc(60% - 30px);

			ul {
				display: flex;
				flex-wrap: wrap;

				li {
					width: 33%;
				}
			}
		}

		.right {
			flex: 1;

			.box {
				display: flex;

				ul {
					width: 50%;
				}
			}
		}

		.tit {
			font-size: 18px;
			padding: 0 13px 18px;
			border-bottom: 1px solid #d1d1d1;
			position: relative;

			&::before {
				content: "";
				width: 3px;
				height: 18px;
				background: #0055ff;
				position: absolute;
				top: 5px;
				left: 0;
			}
		}

		.top {
			display: flex;
			flex-wrap: wrap;
		}

		.center {
			width: 200px;
			margin-right: 40px;
		}

		ul {
			li {
				margin-top: 18px;
				font-size: 14px;
				color: #666666;

				&:hover {
					color: #0055ff;
				}
			}
		}
	}

	.edge {
		padding-top: 0;

		.fc {
			display: flex;

			.menu {
				padding: 54px 0;
				width: 128px;
				border-right: 1px solid #d1d1d1;

				p {
					padding-bottom: 14px;
					margin-bottom: 30px;
					position: relative;
					cursor: pointer;

					&.active {
						color: #0055ff;

						&::before {
							content: "";
							width: 62px;
							height: 2px;
							background: #0055ff;
							position: absolute;
							bottom: 0;
							left: 0;
						}
					}
				}
			}

			.edge_con {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				padding: 54px 30px;

				.edge_item {
					width: calc(33.33% - 6px);
					margin-bottom: 36px;
					margin-right: 9px;
					font-size: 16px;
					cursor: pointer;

					&:nth-of-type(3n) {
						margin-right: 0;
					}

					&:hover {
						color: #0055ff;
					}

					&.active {
						color: #0055ff;
					}

					.text {
						font-size: 14px;
						color: #666666;
						margin-top: 14px;
					}
				}
			}
		}
	}
}

.el-dropdown-menu__item.active {
	background: rgba(0, 0, 0, 0.12);
	color: #222222;
}

.el-dropdown-menu {
	padding: 6px 0;
}
</style>
